import React from 'react'

const DishInfoModal = props => {
  return (
    <div className='dish-modal'>{props.children}</div>
  )
}

export default DishInfoModal